export const renderSanityText = (translation?: any, variables: Record<string, string> = {}) =>
  translation?.content
    ?.map((block: { children: any[] }) =>
      block.children
        ?.map((child) =>
          child.text.replace(
            /\{\{(\w+)\}\}/g,
            (match: any, variableName: string | number) => variables[variableName] ?? ''
          )
        )
        .join('')
    )
    .join('');
